import { Typography } from "@material-ui/core";
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";

export const SpacedDiv = styled('div')(({theme}) => ({
    marginTop: '25px'
}))